import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ConfigProvider } from 'antd';
import axios from 'axios';
import { API_BASE_URL } from './utils/api';

// Set backend URL globally - works with all existing axios calls
axios.defaults.baseURL = API_BASE_URL;

// Render's free tier sleeps when idle; ping it as soon as the app loads so the cold start
// overlaps with the user logging in instead of delaying their first real request.
fetch(`${API_BASE_URL}/api/health`).catch(() => {});

// Add interceptor to attach token to all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 errors globally (redirect to login)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#1890ff',
        borderRadius: 6,
      },
    }}
  >
    <App />
  </ConfigProvider>
);

